export default "__VITE_ASSET__DN1CzXGi__"